var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKey2 = function SvgKey2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.755 2A6.245 6.245 0 0 0 9.51 8.245c0 .388.041.775.102 1.143L2 17v3.755C2 21.45 2.551 22 3.245 22H4.49v-1.245H7v-2.51h2.51v-2.49H12l1.612-1.612a6.2 6.2 0 0 0 2.123.367A6.267 6.267 0 0 0 22 8.245 6.245 6.245 0 0 0 15.755 2m1.878 6.245a1.873 1.873 0 0 1-1.878-1.878c0-1.04.837-1.877 1.878-1.877s1.877.837 1.877 1.877-.857 1.878-1.877 1.878"
  })));
};
export default SvgKey2;